import { getRequest } from '../httpRequest'
import { URL } from '../../config'

export const checkRole = function(token) {
		const roleendpoint = '/allaccess'
    const  userURL =  `${URL.user}${roleendpoint}` 
    return getRequest(userURL,'json',token)
}
  


// WEBPACK FOOTER //
// ./src/utils/helperfunctions/checkRole.js